<template>
  <div id="mySupersuPro" style="position:relative">
    <div class="head-btn t_r">
      <button @click="$router.go(-1)" class="cancelButton cancelButton2 m_l_10 m_r_10"><span>取消</span></button>
      <button @click="save()" class="suerButton suerButton2 m_r_10"><span>保存</span></button>
      <span @click="$router.go(-1)" class="btn-back"><span>返回</span></span>
    </div>
    <div class="m_t_20 tableHeight" style="overflow: auto;max-height: calc(100vh - 200px);padding-bottom: 10px">
      <div>
        <nav>
          <span class="font16 colorGray f_w">下游系统</span>

        </nav>
        <div>
          <div class="allDl p_t_b_15">
            <dl class="allDl_width50 allDl_span60" style="width: 90%">
                <dd style="margin: 0 20px 0 0;width: calc(50% - 23px)">
                  <span style="width: 80px">下游系统名称:</span>
                  <div style="width: calc(100% - 110px)">
                    <input v-model="downstreamData.name" type="text" class="allInput"/>
                  </div>
                </dd>
                <dd style="margin: 0 20px 0 0;width: calc(50% - 23px)">
                  <span style="width: 80px">下游系统Key:</span>
                  <div style="width: calc(100% - 110px)">
                    <input v-model="downstreamData.key" type="text" class="allInput"/>
                  </div>
                </dd>
                <dd style="margin: 10px 20px 0 0;width: calc(50% - 23px)">
                  <span style="width: 80px">描述:</span>
                  <div style="width: calc(100% - 110px)">
                    <input v-model="downstreamData.describe" type="text" class="allInput"/>
                  </div>
                </dd>
            </dl>
          </div>
        </div>
      </div>
      <div v-if="myDonldList && myDonldList.length > 0">
        <nav class="uhTabDiv">
          <div>
            <span class="onUhTabSpan">权限设置</span>
          </div>
        </nav>
        <div class="back_colorWidth p_b_10">
          <div >
            <table class="allTable" cellspacing="0">
              <thead>
              <tr>
                <th colspan="2" style="text-align: left">权限</th>
                <th>是否启用权限</th>
                <th>操作</th>
              </tr>
              </thead>
              <tbody :key="index" v-for="(item, index) in myDonldList">
              <tr>
                <td width="20" colspan="4" class="f_w"  style="text-align: left">
                  <i @click="onClickF(item)" class="icon iconfont iconicon_7 dis_line" :style="{'transform': item.isClickF ? '' : 'rotate(-90deg)'}" style="transition: all .5s"></i>
                  <span class="m_l_10">{{ item.category }}</span>
                </td>
              </tr>
              <tr :key="indexCl" v-for="(itemCl, indexCl) in item.list" v-if="item.isClickF">
                <td width="20"></td>
                <td style="text-align: left">{{ itemCl.wideTableName }}</td>
                <td>
                  <input @change="seltDown(itemCl)" v-model="itemCl.isActive" type="checkbox" class="allSwitch" :id="'checkSWCld1' + index + indexCl">
                  <label :for="'checkSWCld1' + index + indexCl" class="v_m"></label>
                </td>
                <td class="colorYellowF36A20" width="60">
                  <span @click="downSet(itemCl)" class="c_p">设置</span>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <model v-if="showModel" :title="'设置'" :minWidth="'60%'" :onButton="1" v-on:on-cancel="showModel = false" v-on:on-confirm="confirmFractale()">
      <div class="pd_10_20" style="min-height: 30vh;max-height: 50vh;overflow: auto">
        <div class="allDl">
          <dl class="allDl_width50 allDl_span80 allDl_span_tr">
            <dd style="margin-bottom: 20px" :key="index" v-for="(item, index) in myDownSet" v-if="myWorkType === 'Virtual'">
              <span>{{ item.serchName }}</span>
              <div>
                <allSelect v-if="item.newSearchList" v-on:on-change="seltVir($event, item)"  v-model="item.prictData" :multiple="true" :chooseData="item.newSearchList" :needReturn="'id'" :matchValue="'name'" :showValue="'{{name}}'" :width="'100%'" :placeholder="'全部'" :borderLine="'#E5E5E5'">
                </allSelect>
                <allSelect v-else v-on:on-change="seltVir($event, item)"  v-model="item.prictData" :multiple="true" :chooseData="item.serchList" :needReturn="'id'" :matchValue="'name'" :showValue="'{{name}}'" :width="'100%'" :placeholder="'全部'" :borderLine="'#E5E5E5'">
                </allSelect>
              </div>
            </dd>
            <dd style="margin-bottom: 20px" :key="index" v-for="(item, index) in myDownSet" v-if="myWorkType === 'Default'">
              <span>{{ item.serchName }}</span>
              <div>
                <allSelect  v-model="item.prictData" :multiple="true" :chooseData="item.serchList" :needReturn="'id'" :matchValue="'name'" :showValue="'{{name}}'" :width="'100%'" :placeholder="'全部'" :borderLine="'#E5E5E5'">
                </allSelect>
              </div>
            </dd>
          </dl>
        </div>
      </div>
    </model>
  </div>
</template>

<script>
import {console} from 'vuedraggable/src/util/helper'

export default {
  name: 'myAPIGate',
  data () {
    return {
      formId: parseInt(this.$route.query.formId),
      downstreamData: {
        id: 0,
        name: '',
        key: '',
        describe: '',
        lastModifyName: '',
        lastModifyTime: ''
      },
      myDonldList: [],
      showModel: false,
      myDownSet: [],
      myWorkType: '',
      mydownTableId: 0,
      unTableId: 0
    }
  },
  created () {
    if (this.formId > 0) {
      this.getAllDetail()
      this.getWideTableList()
    }
  },
  methods: {
    getAllDetail () {
      this.$axiox.get('/api/Role/GateApiDetail?gateid=' + this.formId).then(msg => {
        if (msg.data) {
          this.downstreamData = JSON.parse(JSON.stringify(msg.data))
        }
      })
    },
    // 获取数据下载列表
    getWideTableList () {
      this.$axiox.get('/api/Role/GetGateWideTableList?gateid=' + this.formId + '&filename=').then(msg => {
        console.log(msg)
        this.myDonldList = msg.data || []
        for (let i = 0; i < this.myDonldList.length; i++) {
          this.$set(this.myDonldList[i], 'isClickF', true)
        }
      })
    },
    // 获取已设置
    getColumnValue (item, callBack) {
      this.$axiox.post(`/api/Role/GetGateColumnValue?gateid=${this.formId}&tableid=${item.id}`).then(msg => {
        if (callBack) {
          callBack(msg)
        }
      })
    },
    getValueList (item) {
      console.log(item)
      if (item.serchList.length <= 1) {
        let data = {
          dbName: item.dataDicTableName,
          dickey: item.key || '',
          keyword: '',
          tableId: this.unTableId,
          isNeedPermissionControl: false,
          PageIndex: 1,
          PageSize: 50
        }
        let url = this.$commonJs.returnQuery('/api/Role/GetRoleVauleByDicKey', data)
        item.serchList = [
          {
            id: '',
            name: '全部'
          }
        ]
        this.$axiox.get(url).then(msg => {
          let list = msg.data || []
          for (let i = 0; i < list.length; i++) {
            let object = {
              id: list[i],
              name: list[i]
            }
            item.serchList.push(object)
          }
        })
      }
    },
    save () {
      if (!this.downstreamData.name) {
        this.$commonJs.alertTips({
          type: 'error',
          title: '错误',
          content: '请输入下游系统名称',
          stayTime: 5
        })
        return
      }
      if (!this.downstreamData.key) {
        this.$commonJs.alertTips({
          type: 'error',
          title: '错误',
          content: '请输入下游系统Key',
          stayTime: 5
        })
        return
      }
      // if (!this.downstreamData.describe) {
      //   this.$commonJs.alertTips({
      //     type: 'error',
      //     title: '错误',
      //     content: '请输入描述',
      //     stayTime: 5
      //   })
      //   return
      // }
      this.$axiox.post('/api/Role/EditGateApi', this.downstreamData).then(msg => {
        console.log(msg)
        this.$commonJs.alertTips({
          type: 'success',
          title: '成功',
          content: '保存成功',
          stayTime: 5
        })
        this.$router.go(-1)
      })
    },
    seltDown (item) {
      this.$axiox.get(`/api/Role/EnableGateWideTable?gateid=${this.formId}&wideid=${item.id}&isenable=${item.isActive}`).then(msg => {
        this.getWideTableList()
      })
    },
    downSet (item) {
      console.log(item)
      this.showModel = true
      this.myWorkType = item.wideTableType
      this.mydownTableId = item.id
      this.unTableId = item.childTableId
      this.myDownSet = []

      let url = ''
      if (item.wideTableType === 'Virtual') {
        url = `/api/Role/GetGateKeyValueMap?gateid=${this.formId}&wideid=${item.id}`
      } else if (item.wideTableType === 'Default') {
        url = `/api/Role/GetGateWideTableSetColumn?gateid=${this.formId}&wideid=${item.id}`
      }
      this.getColumnValue(item, p => {
        this.$axiox.get(url).then(msg => {
          console.log(msg)
          let data1 = {
            id: 1,
            prictData: '',
            serchName: '',
            serchList: [
              {
                id: '',
                name: '全部'
              }
            ]
          }
          let data2 = {
            id: 2,
            prictData: '',
            serchName: '',
            serchList: [
              {
                id: '',
                name: '全部'
              }
            ]
          }
          if (item.wideTableType === 'Virtual') {
            this.edList = []
            if (p.data) {
              let list = []
              for (let i = 0; i < p.data.length; i++) {
                if (p.data[i].key === 'key1') {
                  list.push(p.data[i].value)
                  this.edList.push(p.data[i].value)
                  data1.prictData = list.join(',')
                }
                if (p.data[i].key === 'key2') {
                  list.push(p.data[i].value)
                  data2.prictData = list.join(',')
                }
              }
            }
            let chanlList = msg.data
            data1.serchName = chanlList.key1DisplayName
            for (let i = 0; i < chanlList.key1.length; i++) {
              let data = {
                id: chanlList.key1[i].key1Name,
                name: chanlList.key1[i].key1Name,
                columnName: chanlList.key1[i].key1ColumnName
              }
              data1.serchList.push(data)
            }
            for (let i = 0; i < data1.serchList.length; i++) {
              this.$set(data1.serchList[i], 'clidList', [])
              for (let j = 0; j < chanlList.key2.length; j++) {
                if (data1.serchList[i].name === chanlList.key2[j].key1Name) {
                  this.$set(data1.serchList[i], 'clidList', chanlList.key2[j].key2Name)
                }
              }
            }
            this.myDownSet.push(data1)
            data2.serchName = chanlList.key2DisplayName
            data2.serchList = [
              {
                id: '',
                name: '全部'
              }
            ]
            for (let i = 0; i < chanlList.key2.length; i++) {
              let list = []
              if (this.edList.length > 0) {
                for (let j = 0; j < chanlList.key2[i].key2Name.length; j++) {
                  if (this.edList.indexOf(chanlList.key2[i].key1Name) >= 0) {
                    let data = {
                      id: chanlList.key2[i].key2Name[j],
                      name: chanlList.key2[i].key2Name[j],
                      columnName: chanlList.key1[i].key2ColumnName
                    }
                    list.push(data)
                  }
                }
              } else {
                for (let j = 0; j < chanlList.key2[i].key2Name.length; j++) {
                  let data = {
                    id: chanlList.key2[i].key2Name[j],
                    name: chanlList.key2[i].key2Name[j],
                    columnName: chanlList.key1[i].key2ColumnName
                  }
                  list.push(data)
                }
              }
              data2.serchList = data2.serchList.concat(list)
              data2.serchList = this.$commonJs.returnHeavy(data2.serchList, 'name')
            }
            this.myDownSet.push(data2)
          } else if (item.wideTableType === 'Default') {
            let newList = msg.data || []
            for (let i = 0; i < newList.length; i++) {
              let data = {
                id: newList[i].id,
                key: newList[i].dataDicKey,
                columnName: newList[i].columnName,
                serchName: newList[i].displayColumnName,
                dataDicTableName: newList[i].dataDicTableName,
                prictData: '',
                serchList: [
                  {
                    id: '',
                    name: '全部'
                  }
                ]
              }
              this.myDownSet.push(data)
            }
            let newData = []
            if (p.data) {
              let data = []
              for (let i = 0; i < p.data.length; i++) {
                data.push(p.data[i].key)
              }
              data = this.$commonJs.returnHeavy(data)
              for (let i = 0; i < data.length; i++) {
                let object = {
                  key: data[i],
                  valus: []
                }
                newData.push(object)
              }
              for (let i = 0; i < p.data.length; i++) {
                for (let j = 0; j < newData.length; j++) {
                  if (newData[j].key === p.data[i].key) {
                    newData[j].valus.push(p.data[i].value)
                  }
                }
              }
            }
            for (let i = 0; i < this.myDownSet.length; i++) {
              for (let j = 0; j < newData.length; j++) {
                if (newData[j].key === this.myDownSet[i].key) {
                  this.myDownSet[i].prictData = newData[j].valus.join(',')
                }
              }
              this.getValueList(this.myDownSet[i])
            }
          }
        })
      })
    },
    seltVir (e, item) {
      if (parseInt(item.id) === 1) {
        let list = []
        for (let i = 0; i < item.serchList.length; i++) {
          if (item.prictData === '') {
            list = list.concat(item.serchList[i].clidList)
            list = this.$commonJs.returnHeavy(list)
          }
          if (item.prictData.indexOf(item.serchList[i].id) >= 0) {
            list = list.concat(item.serchList[i].clidList)
            list = this.$commonJs.returnHeavy(list)
          }
        }

        for (let i = 0; i < this.myDownSet.length; i++) {
          if (parseInt(this.myDownSet[i].id) !== parseInt(item.id)) {
            this.myDownSet[i].prictData = ''
            this.myDownSet[i].newSearchList = [
              {
                id: '',
                name: '全部',
                columnName: ''
              }
            ]
            for (let j = 0; j < list.length; j++) {
              for (let k = 0; k < this.myDownSet[i].serchList.length; k++) {
                if (this.myDownSet[i].serchList[k].id === list[j]) {
                  let data = {
                    id: list[j],
                    name: list[j],
                    columnName: this.myDownSet[i].serchList[k].columnName
                  }
                  this.myDownSet[i].newSearchList.push(data)
                }
              }
            }
          }
        }
      } else {
        console.log(item)
      }
    },
    confirmFractale () {
      let list = []
      if (this.myWorkType === 'Virtual') {
        for (let i = 0; i < this.myDownSet.length; i++) {
          let tempSearchList = this.myDownSet[i].newSearchList ? this.myDownSet[i].newSearchList : this.myDownSet[i].serchList
          if (parseInt(this.myDownSet[i].id) === 1) {
            if (this.myDownSet[i].prictData === '') {
              let data = {
                key: 'key1',
                columnName: '',
                value: '*gskallvalue*'
              }
              list.push(data)
            }
            if (this.myDownSet[i].prictData !== '') {
              let newPrict = this.myDownSet[i].prictData.split(',')
              for (let j = 0; j < newPrict.length; j++) {
                for (let k = 0; k < tempSearchList.length; k++) {
                  if (tempSearchList[k].id === newPrict[j]) {
                    let data = {
                      key: 'key1',
                      columnName: tempSearchList[k].columnName,
                      value: newPrict[j]
                    }
                    list.push(data)
                  }
                }
              }
            }
          }
          if (parseInt(this.myDownSet[i].id) === 2) {
            if (this.myDownSet[i].prictData === '') {
              let data = {
                key: 'key2',
                columnName: '',
                value: '*gskallvalue*'
              }
              list.push(data)
            }
            if (this.myDownSet[i].prictData !== '') {
              let newPrict = this.myDownSet[i].prictData.split(',')
              for (let j = 0; j < newPrict.length; j++) {
                for (let k = 0; k < tempSearchList.length; k++) {
                  if (tempSearchList[k].id === newPrict[j]) {
                    let data = {
                      key: 'key2',
                      columnName: tempSearchList[k].columnName,
                      value: newPrict[j]
                    }
                    list.push(data)
                  }
                }
              }
            }
          }
        }
      } else {
        let valueList = []
        for (let i = 0; i < this.myDownSet.length; i++) {
          if (this.myDownSet[i].prictData === '') {
            let data = {
              key: this.myDownSet[i].key,
              columnName: this.myDownSet[i].columnName,
              value: '*gskallvalue*'
            }
            list.push(data)
          }
          if (this.myDownSet[i].prictData) {
            valueList = valueList.concat(this.myDownSet[i].prictData.split(','))
          }
        }
        for (let i = 0; i < this.myDownSet.length; i++) {
          for (let j = 0; j < valueList.length; j++) {
            if (this.myDownSet[i].prictData.indexOf(valueList[j]) >= 0) {
              console.log('this.myDownSet[i]----' + JSON.stringify(this.myDownSet[i]))
              let data = {
                key: this.myDownSet[i].key,
                columnName: this.myDownSet[i].columnName,
                value: valueList[j]
              }
              list.push(data)
            }
          }
        }
      }
      console.log('提交----list' + JSON.stringify(list))
      // return
      this.$axiox.post('/api/Role/AddGateColumnValue?gateid=' + this.formId + '&tableid=' + this.mydownTableId, list).then(msg => {
        this.$commonJs.alertTips({
          type: 'success',
          title: '成功',
          content: '设置成功',
          stayTime: 5
        })
        this.showModel = false
        this.getWideTableList()
      })
    }
  }
}
</script>

<style scoped>
.onUhTabSpan, .onUhTabLi{
  color:#666 !important;
  font-size:16px;
}
.uhTabDiv > div > span{
  padding:10px 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/mySystemMessager/myAPIGate.vue